<template>
  <div class="flex flex-column align-items-center">
    <loader/>
    <h3 class="mt-3">{{ trans('dashboard.setup.title') }}</h3>
  </div>
</template>

<script>
import DashboardLayout from "@/Layouts/DashboardLayout";
import Loader from "@/components/Shared/Loader";

export default {
  name: "Setup",

  layout: DashboardLayout,

  components: {
    Loader
  },

  data: () => ({
    interval: null
  }),

  beforeMount() {
    this.interval = setInterval(() => {
      this.$inertia.reload({replace: true})
    }, 5000)
  },

  beforeUnmount() {
    clearInterval(this.interval)
  }
}
</script>
